import React from "react";
import "./Committees.css";

const committees = [
  {
    name: "UNESCO",
    full: "United Nations Educational, Scientific and Cultural Organization",
    topic: "Preserving Indigenous Languages and Knowledge Systems",
    description: `Indigenous languages carry centuries of wisdom, oral traditions, and cultural expressions that define the identity of entire communities. As globalization advances, thousands of these languages are at risk of extinction. The preservation of indigenous languages is not merely linguistic conservation — it is the protection of humanity’s shared heritage. Delegates must explore bilingual education, digital archiving, cultural revitalization programs, and empower indigenous communities to lead these efforts.`
  },
  {
    name: "DISEC",
    full: "Disarmament and International Security Committee",
    topic: "Tackling the Threat of Cyber Weapons in Modern Conflicts",
    description: `Cyber warfare is a defining security challenge of the 21st century. Cyber weapons transcend borders and target critical societal systems — energy grids, hospitals, elections, financial networks — often without accountability. Delegates must work toward global definitions of cyber aggression, cooperative defense frameworks, transparency mechanisms, and prevention diplomacy to safeguard global stability.`
  },
  {
    name: "UNICEF",
    full: "United Nations International Children’s Emergency Fund",
    topic: "Providing Equal Access to Early Childhood Education in Rural Areas",
    description: `Early childhood education shapes lifelong opportunity and equality. Yet children in rural regions face barriers such as poverty, lack of educators, poor transportation, and limited infrastructure. Delegates must propose inclusive policies such as teacher training programs, mobile classrooms, digital learning networks, and community engagement strategies that ensure no child is left behind.`
  },
  {
    name: "SOCHUM",
    full: "Social, Humanitarian and Cultural Committee",
    topic: "Ensuring the Rights of Children in Armed Conflicts",
    description: `Children in war zones are exposed to trauma, displacement, recruitment into armed groups, and loss of access to healthcare and education. Delegates must address international monitoring, rehabilitation and reintegration systems, enforcement of international law, and cooperative humanitarian action to restore hope and protect childhood.`
  },
  {
    name: "UNEP",
    full: "United Nations Environment Programme",
    topic: "Combating the Global Rise in Wildfires Due to Climate Change",
    description: `Climate change is increasing the scale and frequency of wildfires, destroying ecosystems, releasing carbon, displacing populations, and deepening inequality. Delegates must explore wildfire early-warning systems, sustainable land management, reforestation, climate adaptation planning, and multilateral cooperation to build resilience.`
  },
  {
    name: "WHO",
    full: "World Health Organization",
    topic: "Improving Global Access to Vaccinations for Preventable Diseases",
    description: `Vaccines are among humanity’s most powerful public health tools, yet access remains unequal. Delegates must address distribution logistics, financial assistance models, intellectual property policy, healthcare worker support, and community education strategies to build global vaccination equity.`
  },
  {
    name: "ECOFIN",
    full: "Economic and Financial Committee",
    topic: "Bridging the Economic Gap Between Developed and Developing Countries Through Fair Trade",
    description: `Global inequality persists as developing nations face exploitative trade conditions and limited access to capital. Delegates must design frameworks centered on ethical trade pricing, capacity-building programs, economic autonomy, and equitable market participation to promote sustainable and inclusive growth.`
  },
  {
    name: "SPECPOL",
    full: "Special Political and Decolonization Committee",
    topic: "The Question of Self-Determination in Modern-Day Colonized Territories",
    description: `Despite formal decolonization, many regions still face political, military, or economic domination that limits sovereignty. Delegates must evaluate pathways to self-governance, reconciliation, and independent development, while ensuring peaceful and democratic transitions rooted in dignity and justice.`
  },
  {
    name: "FAO",
    full: "Food and Agriculture Organization",
    topic: "Promoting Sustainable Agricultural Practices in Water-Scarce Regions",
    description: `Water scarcity threatens agricultural productivity and food security. Delegates must develop sustainable irrigation strategies, soil conservation systems, drought-resistant crops, and international support networks to protect livelihoods and ensure food stability.`
  },
  {
    name: "LEGAL",
    full: "Sixth Committee – Legal Committee",
    topic: "Establishing Legal Frameworks for Artificial Intelligence Usage",
    description: `AI development is outpacing ethical and legal safeguards. Delegates must define standards for transparency, data privacy, algorithmic fairness, accountability systems, and international governance to ensure AI serves humanity rather than controls it.`
  },
  {
    name: "UN Women",
    full: "United Nations Entity for Gender Equality and the Empowerment of Women",
    topic: "Combatting Gender-Based Violence in Educational Institutions",
    description: `Gender-based violence in schools and universities threatens safety, dignity, and access to education. Delegates must develop prevention frameworks, enforce reporting and accountability systems, empower survivors, and support cultural change toward gender equality.`
  },
  {
    name: "UNDP",
    full: "United Nations Development Programme",
    topic: "Reducing Youth Unemployment Through Innovation and Entrepreneurship",
    description: `Youth unemployment limits social stability and economic potential. Delegates must propose policies that expand digital skills training, fund youth-led ventures, remove bureaucratic barriers to entrepreneurship, and build innovation-driven economic ecosystems.`
  },
  {
    name: "UNPFII",
    full: "United Nations Permanent Forum on Indigenous Issues",
    topic: "Identity Crisis Among Indigenous Youth Due to Cultural and Language Loss",
    description: `Cultural erosion creates psychological disconnection, loss of identity, and intergenerational trauma. Delegates must support heritage revitalization, arts, intergenerational language transmission, and culturally rooted education models.`
  },
  {
    name: "IOM",
    full: "International Organization for Migration",
    topic: "Managing Migration Flows in the Face of Environmental Displacement",
    description: `Climate change is forcing millions to migrate. Delegates must propose humane relocation programs, climate adaptation strategies, and legal recognition for environmental refugees while balancing national security and human dignity.`
  },
  {
    name: "UNHRC",
    full: "United Nations Human Rights Council",
    topic: "Addressing the Rise of Online Hate Speech and Its Impact on Youth",
    description: `Online hate speech fuels radicalization, psychological harm, and social division. Delegates must promote content accountability, digital literacy education, youth protection policies, and global cooperation against digital extremism.`
  }
];

const Committees = () => (
  <div className="committees-container">
    <h1>Committees</h1>
    <div className="committees-list">
      {committees.map((c, i) => (
        <div className="committee-card" key={i}>
          <h2>{c.name}</h2>
          <p className="full">{c.full}</p>
          <h3>Topic: {c.topic}</h3>
          <p>{c.description}</p>
        </div>
      ))}
    </div>
  </div>
);

export default Committees;
